export default __webpack_public_path__ + "static/media/coloring-pages-white.6bb9441a.svg";